import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

//toggle a class to the home header to add bg-color to navbar
const homeHeaderScroll = () => {
  let timeout;
  const navbar = document.querySelector('.navbar');

  if (window.scrollY > 49 && !navbar.classList.contains('navbar--bg')) {
    navbar.classList.add('navbar--bg');
  }

  window.addEventListener('scroll', function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      if (window.scrollY > 49 && !navbar.classList.contains('navbar--bg')) {
        navbar.classList.add('navbar--bg');
      } else if (
        window.scrollY < 49 &&
        navbar.classList.contains('navbar--bg')
      ) {
        navbar.classList.remove('navbar--bg');
      }
    }, 200);
  });
};

//add carrousel in home header
const homeHeaderSwiper = () => {
  const homeHeaderCarousels = document.querySelectorAll(
    '.home-header__carrousel'
  );

  if (0 < homeHeaderCarousels.length) {
    homeHeaderCarousels.forEach(function (homeHeaderCarousel) {
      const swiperConfig = {
        slidesPerView: 1,
        navigation: {
          nextEl: homeHeaderCarousel.querySelector('.swiper-button-next'),
          prevEl: homeHeaderCarousel.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: '.swiper-pagination--header-home',
          clickable: true,
        },
        breakpoints: {
          1280: {
            direction: 'vertical',
          },
        },
      };

      new Swiper(
        homeHeaderCarousel.querySelector('.home-header__swiper'),
        swiperConfig
      );
    });
  }
};

/////////////// ON READY /////////////////
domReady(() => {
  homeHeaderScroll();
  homeHeaderSwiper();
});
